export default __webpack_public_path__ + "static/media/less.35c3e2d8.svg";